import { render, staticRenderFns } from "./ReportaProblem.vue?vue&type=template&id=3fe48582&scoped=true&"
import script from "./ReportaProblem.vue?vue&type=script&lang=js&"
export * from "./ReportaProblem.vue?vue&type=script&lang=js&"
import style0 from "./ReportaProblem.vue?vue&type=style&index=0&id=3fe48582&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe48582",
  null
  
)

export default component.exports